export default "__VITE_ASSET__BFEQx$Ga__"